import React from 'react'
import styled, { css } from 'styled-components'

export const Container = styled.section`
  border: ${props => props.theme.seperator};
  border-radius: 6px;
  overflow: hidden;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`

const calcHeight = (size) => {
  if (size === 'sm') {
    return `3rem`
  } else if (size === 'lg') {
    return `5rem`
  }

  return 'auto'
}

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;

  &:not(:last-child) {
    border-bottom: ${props => props.theme.seperator};
  }
`

export const StripedRow = styled(Row)`
  &:nth-child(odd) {
    background: ${props => props.theme.grey};
  }
`

export const itemMixin = css`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  height: ${props => calcHeight(props.size) };
`

export const bigItemMixin = css`
  ${itemMixin}

  @media (min-width: 700px) {
    width: 50%;
    &:not(:last-child) {
      border-right: ${props => props.theme.seperator};
    }
  }

  @media (max-width: 699px) {
    width: 100%;
    justify-content: center;
    text-align: center;
    &:not(:last-child) {
      border-bottom: ${props => props.theme.seperator};
    }
  }
`

export const lilItemMixin = css`
  ${itemMixin}
  flex-basis: 0;
  flex-grow: 1;
  justify-content: center;

  &:not(:last-child) {
    border-right: ${props => props.theme.seperator};
  }
`

export const headerMixin = css`
  background: ${props => props.theme.blue};
  color: white;

  &:only-child {
    flex-grow: 1;
  }
`

export const Title = styled.div`
  ${bigItemMixin}
  ${headerMixin}
`

export const Header = styled.div`
  ${lilItemMixin}
  text-align: center;
  @media (min-width: 700px) {
    ${headerMixin}
  }
`

const ColoredContainer = styled(Container)`
  ${itemMixin}
  text-align: center;
  justify-content: center;
  background: ${props => props.theme[props.background]};
  color: ${props => props.theme[props.text]};
`

export const Alert = ({ id, theme, type, children }) => {
  let background = '';
  let text = '';

  if (type === 'caution') {
    background = 'yellow'
    text = 'black'
  } else if (type === 'success') {
    background = 'green'
    text = 'white'
  } else if (type === 'warning') {
    background = 'red'
    text = 'white'
  }

  return (
    <ColoredContainer id={id} background={background} text={text}>
      { children }
    </ColoredContainer>
  )
}

export const Intro = styled.div`
  ${lilItemMixin}
  padding: 1rem;
  text-align: center;
`

export default ({ title, headers, intro, children }) => {

  let index = 0
  const headerItems = headers ? headers.map(item => {
    let text = item
    const words = text.split(' ')
    if (words.length === 2) {
      text = <>{words[0]}<br/>{words[1]}</>
    }
    return <Header key={index++}>{text}</Header>
  }) : null

  return (
    <Container>
      <Row>
        <Title>{title}</Title>
        {headerItems}
      </Row>
      {intro ? <Row><Intro>{intro}</Intro></Row> : null}
      {children}
    </Container>
  )
}
